export enum EVisitStatus {
  REQUESTED = 'REQUESTED',
  REVIEWING = 'REVIEWING',
  STARTED = 'STARTED',
  COMPLETED = 'COMPLETED',
  SCHEDULED = 'SCHEDULED',
  CALL_ENDED = 'CALL_ENDED',
  PENDING_TASKS = 'PENDING_TASKS',
  CANCELED = 'CANCELED',
}
